import { request } from '@/utils/api-request'

type Params = Record<string, unknown>;

export function getBeusPlanList () {
  const url = '/admin/beus/plan/get_plan_list'
  const config = {
    method: 'get',
    skipError: true,
    url
  }
  return request(config, true, '24h')
}

export function getBaPlanList () {
  const url = '/admin/ba/plan/get_plan_list'
  const config = {
    method: 'get',
    url
  }
  return request(config, true, '24h')
}

export const getBoardList = () => {
  const url = '/admin/payment/manual/dashboard'
  const config = {
    method: 'get',
    url
  }
  return request(config, true)
}

export const getUserInfo = (params: Params) => {
  const url = '/admin/payment/manual/get_user'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getCustomerInfo = (params: Params) => {
  const url = '/admin/payment/manual/get_customer_info'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const createRequest = (params: Params) => {
  const url = '/admin/payment/manual/create_request'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getRequestInfo = (params: Params) => {
  const url = '/admin/payment/manual/info'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const uploadImagetoServer = (params: Params) => {
  const url ='/admin/payment/manual/image_upload'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const updateTask = (params: Params) => {
  const url ='/admin/payment/manual/update_sub'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getRequestList = (params: Params) => {
  const url = '/admin/payment/manual/request_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const removeRequest = (params: Params) => {
  const url = '/admin/payment/manual/remove_request'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const modifyRequest = (params: Params) => {
  const url = '/admin/payment/manual/modify_request'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getPlanList = (params: Params) => {
  const url = '/admin/payment/manual/plan_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getPaymentList = (params: Params) => {
  const url = '/admin/payment/manual/payment_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

// customer
export const getCustomerList = (params: Params) => {
  const url = '/admin/customer/manual/customer_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const getCustomer = (params: Params) => {
  const url = '/admin/customer/manual/customer_info'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const createCustomer = (params: Params) => {
  const url = '/admin/customer/manual/add_customer'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const removeCustomer = (params: Params) => {
  const url = '/admin/customer/manual/remove_customer'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const modifyCustomer = (params: Params) => {
  const url = '/admin/customer/manual/modify_customer'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export const checkUserExist = (params: Params) => {
  const url = '/admin/customer/manual/check_user_exist'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

